import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteJurisdictionResourceMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
}>;


export type DeleteJurisdictionResourceMutation = { __typename?: 'mutation_root', delete_jurisdiction_resources_by_pk?: { __typename?: 'jurisdiction_resources', id: any } | null };


export const DeleteJurisdictionResourceDocument = gql`
    mutation deleteJurisdictionResource($id: uuid!) {
  delete_jurisdiction_resources_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteJurisdictionResourceMutationFn = Apollo.MutationFunction<DeleteJurisdictionResourceMutation, DeleteJurisdictionResourceMutationVariables>;

/**
 * __useDeleteJurisdictionResourceMutation__
 *
 * To run a mutation, you first call `useDeleteJurisdictionResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJurisdictionResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJurisdictionResourceMutation, { data, loading, error }] = useDeleteJurisdictionResourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteJurisdictionResourceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteJurisdictionResourceMutation, DeleteJurisdictionResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteJurisdictionResourceMutation, DeleteJurisdictionResourceMutationVariables>(DeleteJurisdictionResourceDocument, options);
      }
export type DeleteJurisdictionResourceMutationHookResult = ReturnType<typeof useDeleteJurisdictionResourceMutation>;
export type DeleteJurisdictionResourceMutationResult = Apollo.MutationResult<DeleteJurisdictionResourceMutation>;
export type DeleteJurisdictionResourceMutationOptions = Apollo.BaseMutationOptions<DeleteJurisdictionResourceMutation, DeleteJurisdictionResourceMutationVariables>;